import { forwardRef, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import InputLabel from "../InputLabel";
import { SelectBox } from "@earned/core";

interface FinraAssociationSelectProps {
  value?: boolean | null;
  required?: boolean;
  error?: FieldError;
  autoFocus?: boolean;
  label?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
}

const FinraAssociationSelect = forwardRef<
  HTMLDivElement,
  FinraAssociationSelectProps
>(({ required, error, value, label, onChange, ...rest }, ref) => {
  const options = [
    { id: "true", value: true, label: "Yes" },
    { id: "false", value: false, label: "No" },
  ];
  return (
    <div className="relative flex flex-col">
      {!!label && <InputLabel value={label} required={required} />}
      <SelectBox
        ref={ref}
        selected={options?.find((o) => o.value === value) ?? options[1]}
        options={options}
        required={required}
        error={error?.message}
        onChange={(opt) => onChange(opt.value)}
        {...rest}
      />
    </div>
  );
});

FinraAssociationSelect.displayName = "FinraAssociationSelect";

export default FinraAssociationSelect;
